<template>
  <div class="wrapper">

    <div class="header_wrapper">
      <v-toolbar
        color="primary"
        dark
      >
        <v-btn
          @click="routerBack"
          style="position: absolute"
          icon
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-spacer />
        <v-toolbar-title>保護者票</v-toolbar-title>
        <v-spacer />
        <v-btn
          @click="clickPost"
          :loading="btnLoading"
          class="no-background-hover"
          style="position: absolute;　right: 20px;"
          icon
        >
          保存
        </v-btn>
      </v-toolbar>
    </div>

    <div
      v-if="fetchLoading"
      class="d-flex align-center"
      style="height: calc(100vh - 56px)"
    >
      <vue-loading
        loader="bars"
        color="#EE6090"
        :size="{ width: '30px', height: '30px' }"
      ></vue-loading>
    </div>

    <v-form
      ref="post_parentinfo_form"
      class="form_wrapper px-2 py-3"
      v-if="!fetchLoading && answers.length"
    >

      <div
        v-for="(f, index) in formats"
        :key="f.key"
      >
        <children-field
          :format="f"
          :answers="answers"
          :index="index"
          @inputValue="inputValue"
        />

      </div>

    </v-form>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from 'vue';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
dayjs.locale('ja');
import { Toast } from '@/service/SweetAlert';

import { parentModule } from '@/store/entityModules/parent';

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

import ChildrenField from '@/components/organisms/ChildrenField.vue';

import { VForm } from '@/model/Vuetify/VForm';
import { ChildInfoFormat } from 'chaild-entity/src/component/nursery/child/types';

interface DataType {
  childId: number;
  childName: string;
  fetchLoading: boolean;
  btnLoading: boolean;
  answers: Array<{
    key: string;
    value: any | null;
  }>;
}

export default defineComponent({

  components: {
    'vue-loading': Loading,
    ChildrenField,
  },

  computed: {
    form(): VForm {
      return (this.$refs as any).post_parentinfo_form;
    },
    formats() {
      return parentModule.formats;
    },
  },

  data: (): DataType => ({
    childId: NaN,
    childName: '',
    fetchLoading: false,
    btnLoading: false,
    answers: [],
  }),

  methods: {
    routerBack() {
      this.$router.replace('/setting');
    },
    async clickPost() {
      if (this.form.validate()) {
        this.btnLoading = true;
        try {
          let answers = this.answers;
          answers = answers.map((a) => {
            if (Array.isArray(a.value)) {
              a.value = a.value.filter(Boolean);
            }
            return a;
          });
          const response = await parentModule.postParentInfo({
            answers,
          });
          this.btnLoading = false;
          Toast.fire({
            icon: 'success',
            title: '保存が完了しました',
          });
        } catch (error) {
          this.btnLoading = false;
        }
      }
    },
    inputValue({ format, value }: {
      format: ChildInfoFormat;
      value: string;
    }) {
      this.answers.map((a) => {
        if (a.key === format.key) {
          a.value = value;
        }
      });
    },
    initInfo() {
      if (parentModule.parentInfo) {
        parentModule.parentInfo.map((info) => {
          this.answers.map((answer) => {
            if (answer.key === info.key) {
              answer.value = info.value;
            }
          });
        });
      }
    },
  },

  async mounted() {
    // if (parentModule.formats.length === 0 && !parentModule.parentInfo) {
    //   this.fetchLoading = true;
    //   await Promise.all([
    //     parentModule.fetchParentInfoFormat(),
    //     parentModule.fetchParentInfo(),
    //   ]);
    //   this.fetchLoading = false;
    // } else if (parentModule.formats.length === 0) {
    //   this.fetchLoading = true;
    //   await parentModule.fetchParentInfoFormat();
    //   this.fetchLoading = false;
    // } else if (!parentModule.parentInfo) {
    //   this.fetchLoading = true;
    //   await parentModule.fetchParentInfo();
    //   this.fetchLoading = false;
    // }
    this.fetchLoading = true;
    await Promise.all([
      parentModule.fetchParentInfoFormat(),
      parentModule.fetchParentInfo(),
    ]);
    for (const f of parentModule.formats) {
      this.answers.push({
        key: f.key,
        value: null,
      });
    }
    this.fetchLoading = false;
    this.initInfo();
  },
});
</script>
<style lang="scss" scoped>
.wrapper {
  @supports (bottom: env(safe-area-inset-bottom)) {
    padding-top: calc(env(safe-area-inset-top) + 64px);
    margin-bottom: calc(env(safe-area-inset-bottom) + 56px);
  }

  .header_wrapper {
    height: 56px;
    width: 100%;
    position: fixed;
    z-index: 1;

    .outline {
      border: 1px solid rgb(var(--v-theme-primary));
    }
    @supports (bottom: env(safe-area-inset-bottom)) {
      padding-top: env(safe-area-inset-top);
    }
  }

  .content_wrapper {
    min-height: calc(100% - 56px);
    margin: 56px 0 0px;
    overflow-y: hidden;
  }
}
</style>
